import { MultiAnalytics, trackerIds } from '@zg-rentals/analytics';

const logger = getLogger('utils/analytics');

let instance = null;
class MultiAnalyticsModule {
  static getInstance() {
    if (!instance) {
      logger.error('ERRORMultiAnalytics: no instance created');
    }

    return instance;
  }

  constructor() {
    if (!instance) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      instance = this;
    }

    return instance;
  }

  init({ isProd }) {
    this.isProd = isProd;

    const ids = [];

    if (this.isProd) {
      const gtmProdId = trackerIds.ids.gtm.prod;
      const comscoreProdId = trackerIds.ids.comscore.prod;
      const dspProdId = trackerIds.ids.dsp.prod;
      ids.push(gtmProdId, comscoreProdId, dspProdId);
    } else {
      const gtmDevId = trackerIds.ids.gtm.dev;
      const comscoreDevId = trackerIds.ids.comscore.dev;
      const dspDevId = trackerIds.ids.dsp.dev;
      ids.push(gtmDevId, comscoreDevId, dspDevId);
    }

    logger.debug({ ids, isProd }, 'creating MultiAnalytics with trackerids');

    this.ma = new MultiAnalytics({
      ids: [...ids, trackerIds.ids.ua.zrm],
      drymode: false,
      logger,
    });

    return instance;
  }

  getMa() {
    return this.ma;
  }
}

export default MultiAnalyticsModule;
